import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { KonPermission } from 'app/modules/UIKit/components/kontable/utility/utility-model';
import { Supplier, SupplierCertification } from '../../../../models/supplier.model';
import { DataTableService } from '../../../../modules/UIKit/components/dataTable/dataTable.service';
import { DataTableCustomButton } from '../../../../modules/UIKit/components/dataTable/dataTableCustomButton.interface';
import { DataTableField } from '../../../../modules/UIKit/components/dataTable/dataTableField.interface';
import { SupplierService } from '../../../../services/supplier/supplier.service';

@Component({
    selector: 'app-supplier-certification',
    templateUrl: './supplier-certification.component.html'
})
export class SupplierCertificationComponent implements OnInit {

  @Input() supplier: Supplier;
  @Output() onBack: EventEmitter<any> = new EventEmitter<any>();

  private titles: DataTableField[];
  private customButtons: DataTableCustomButton[];
  public perm: KonPermission = new KonPermission();
  modalTitle = '';
  labels = {};
  certifications: SupplierCertification[];

  constructor(
    public svc: SupplierService,
    private srvDataTable: DataTableService,
    private translate: TranslateService) {

      this.translate.get([
        'common.code',
        'common.certification_id',
        'common.certification_code',
        'common.back'
      ]).subscribe((res) => {
        console.log(res);
        this.titles = [
          { id: 'id', label: '#' },
          { id: 'certification_id', label: res['common.certification_id'] },
          { id: 'certification_code', label: res['common.certification_code'] },
        ];

        this.customButtons = [
          {
            callbackname: 'back',
            icon: null,
            isAlwaysEnabled: true,
            label: res['common.back']
          }
        ]

      });
  }
  ngOnInit() {
    this.translate.get([
      'supplierCertificationList.add_title',
      'supplierCertificationList.edit_title'
    ]).subscribe((res) => {
      this.labels['add_title'] = res['supplierCertificationList.add_title'];
      this.labels['edit_title'] = res['supplierCertificationList.edit_title'];
    });

    this.reloadList();
    this.perm.edit = false;
    this.perm.view = false;
  }

  reloadList() {
    this.svc.getSupplierCertifications(this.supplier.id).subscribe(res => this.certifications = res);
  }

  showAddOrEditDialog(data): void {
    this.modalTitle = data == null ? this.labels['add_title'] : this.labels['edit_title'];
    this.svc.editing_supplier_certification = data == null ? new Supplier() : data;
  }

  delete (entry): void {
    this.svc.deleteSupplierCertification(this.supplier.id, entry.id).subscribe(() => {
      this.reloadList()
    });
  }

  onAddElement(entry): void {
    entry.supplier_id = this.supplier.id;
    this.svc.postSupplierCertification(this.supplier.id, entry).subscribe(() => {
      this.srvDataTable.get('dt_supplier_certs').showDetail = false;
      this.svc.editing_supplier_certification = null;
      this.reloadList()
    });
  }

  onCustomButton(event) {
    this.onBack.emit();
  }

  onDialogHide () {
    this.svc.editing_supplier_certification = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/supplier/supplier-certification/supplier-certification.component.ts